import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ngTemplateType]',
  standalone: true,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class NgTemplateAssertType<T> {
  public static ngTemplateContextGuard<T>(dir: NgTemplateAssertType<T>, ctx: any): ctx is T {
    return true;
  }

  @Input() public ngTemplateType: T;

  constructor(
    private _templateRef: TemplateRef<T>,
    private _viewContainer: ViewContainerRef,
  ) {}
}

@Directive({
  selector: '[ngTemplateNarrowType]',
  standalone: true,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class NgTemplateSwitchType<T = unknown> {
  public static ngTemplateGuard_ngTemplateNarrowType: 'binding';
  public static ngTemplateContextGuard<T>(dir: NgTemplateSwitchType<T>, ctx: any): ctx is T {
    return true;
  }

  @Input() public ngTemplateNarrowType: T;

  constructor(
    private _viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<T>,
  ) {}
}
